import { render, staticRenderFns } from "./marketPage.vue?vue&type=template&id=5dd45a06&scoped=true&"
import script from "./marketPage.vue?vue&type=script&lang=js&"
export * from "./marketPage.vue?vue&type=script&lang=js&"
import style0 from "./marketPage.vue?vue&type=style&index=0&id=5dd45a06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd45a06",
  null
  
)

export default component.exports